<template>
  <div>
    <b-modal
      v-show="!modalLoads"
      id="modal-terminate"
      ref="terminate-modal"
      :no-close-on-backdrop="true"
      ok-only
      ok-variant="danger"
      ok-title="Close"
      centered
      :title="caseStateTitle"
      size="lg"
      modal-class="modal-danger"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          variant="danger"
          :show="alertErrors.length > 0"
          class="mb-1"
        >
          <div
            v-for="(row, index) in alertErrors"
            :key="index"
            class="alert-body"
          >
            <feather-icon

              icon="InfoIcon"
              class="mr-50"
            />
            {{ row }}
          </div>
        </b-alert>
        <b-form>
          <b-row>
            <b-col
              sm="12"
            >
              <b-form-group
                :label="$t('DEBTIA_REASON')"
                label-for="reason"
                class="mb-2"
              >
                <v-select
                  v-model="caseData.reason"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="reasonOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="reason"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col
              sm="12"
            >
              <b-form-group
                :label="$t('DEBTIA_DESCRIPTION')"
                label-for="description"
                class="mb-2"
              >
                <b-form-textarea
                  id="textarea-rows"
                  v-model="caseData.description"
                  :placeholder="$t('DEBTIA_DESCRIPTION')"
                  rows="8"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BForm, BOverlay, BFormTextarea, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BOverlay,
    vSelect,
    BFormTextarea,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    caseData: {
      type: Object,
      required: true,
    },
    caseStateTitle: {
      type: String,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth())
    // minDate.setDate(15)
    // 15th in two months
    // const maxDate = new Date(today)
    // maxDate.setMonth(maxDate.getMonth() + 2)
    // maxDate.setDate(15)
    return {
      snowOption: {
        theme: 'snow',
      },
      loader: false,
      details: [],
      selected: true,
      confirmCost: false,
      confirmResumeState: true,
      required,
      state: '',
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
      modalLoader: true,
      useCaseData: { ...this.caseData },
      alertErrors: [],
      min: minDate,
      reasonOptions: [],
      requestArgs: [
        { request: '/get-reason-options', param: 'reasonOptions' },
      ],
      args: [{ label: 'test', value: 't' }],
    }
  },
  setup() {
    // const reasonOptions = []
    const reasonOptionsArgs = []
    /* const requestArgs = [
      { request: '/get-reason-options', param: 'reasonOptions' },
    ] */
    return {
      // reasonOptions,
      reasonOptionsArgs,
      // requestArgs,
    }
  },
  watch: {
    caseData: {
      deep: true,
      handler(newValue) {
        console.log('Selected users changed ddd', newValue)
        this.details = { ...this.caseData }
      },
    },
    selected: {
      deep: true,
      handler(newValue) {
        console.log('Selected settings changed', newValue)
      },
    },
    confirmCost: {
      deep: true,
      handler(newValue) {
        console.log('Selected confirmCost changed', newValue)
      },
    },
    confirmResumeState: {
      deep: true,
      handler(newValue) {
        console.log('Selected sate changed', newValue)
      },
    },
  },
  created() {
    this.getReasons()
  },
  methods: {
    async showModal() {
      this.$refs['terminate-modal'].show()
    },
    async getReasons() {
      try {
        await Promise.all(
          this.requestArgs
            .map(REQUEST => axios
              .get(REQUEST.request)
              .then(res => {
                if (REQUEST.param === 'reasonOptions') {
                  this.reasonOptions = [...res.data.data]
                }
              })),
        )
          .then(() => {
            this.loading = false
          })
      } catch (error) {
        console.log('options error', error)
      }
    },
    makeSuccessToast() {
      this.$bvToast.toast('Case Details have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        if (this.confirmResumeState) {
          this.$refs.manageCaseForm.validate().then(success => {
            if (success) {
              this.loader = true
              // const url = `${constants.baseUrl}/update-debt-case`
              this.details.user_id = JSON.parse(localStorage.getItem('userData')).data.id
              this.details.receive_reminder = this.selected
              this.details.confirm_resume_state = this.confirmResumeState
              this.details.is_cost = this.confirmCost
              this.details.creditor_id = this.caseData.creditor_id
              this.details.employee_name = JSON.parse(localStorage.getItem('userData')).data.name
              const data = { ...this.details }
              axios.post('update-debt-case', data).then(response => {
                console.log('done', response)
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CoffeeIcon',
                    variant: 'primary',
                    text: 'Case state has been updated successfully.',
                  },
                })
                this.loader = false
                this.$refs['terminate-modal'].hide()
                this.reloadMethod()
                // window.location.reload()
              }).catch(err => {
                if (err.response.data.message) {
                  this.alertErrors.push(err.response.data.message)
                }
              })
            } else {
              this.loading = false
              reject()
            }
          })
        }
      })
    },
    show() {
      this.$refs['terminate-modal'].show()
    },
  },
  // mounted() {
  //   this.showModal()
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
